import React from "react";

function InventoryCheck() {
  return <div>InventoryCheck</div>;
}

export default InventoryCheck;
